import React from 'react';
import { theme } from '../theme';

// The 24px ghost header button both detail hosts inlined for ✕ — single home now.
// `title` splits the HOVER face off the ACCESSIBLE name (fix round 1, 2026-09-09). They are the
// same string for every caller that omits it — and must stay so, that is the ordinary case. The
// split exists for a surface that mounts several of these side by side (PanelSection's per-section
// Maximieren): each needs a name that says WHICH section, while a pointer user can already see
// which control they are on and is better served by the plain verb.
// `disabled` (Part C wave 2, 2026-09-09) keeps a control that is momentarily unavailable IN PLACE
// rather than unmounting it — the house rule for every other disabled affordance in the app: the
// button stays, dimmed, and its `title` says why. Unmounting it instead would move every icon
// beside it, which is the reflow the layout law forbids. The one case that legitimately mounts
// NOTHING is a control that will never apply to that object at all (a receipt has no edit) — an
// absence, not a state.
export const HeaderIconButton: React.FC<{
  label: string; onClick: () => void; children: React.ReactNode; title?: string; disabled?: boolean;
}> = ({ label, onClick, children, title, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
    title={title ?? label}
    style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      width: 24, height: 24, padding: 0, cursor: disabled ? 'not-allowed' : 'pointer',
      background: 'transparent', border: 'none', borderRadius: theme.borderRadius.sm,
      color: theme.colors.navyMuted, outline: 'none',
      opacity: disabled ? 0.4 : 1,
    }}
  >
    {children}
  </button>
);
